<template>
  <v-container>
    <ComponentPicker
      v-model="value.component"
      title="DataForm"
      :containers="containers"
      :is-required="true"
      :page-model="true"
    />
  </v-container>
</template>

<script>
import ComponentPicker from "../shared/ComponentPicker.vue";

export default {
  name: "AddDesigner",

  components: { ComponentPicker },

  props: ["value", "containers"],
};
</script>
